import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import {
  DossierTransactionPaginationList,
  DossierTransactionType,
} from "../../types/DossierTransaction";
import { PaginationFilters } from "../../types/Pagination";

export type DossierTransactionFilters = PaginationFilters & {
  dossierId: string;
  transactionTypes?: DossierTransactionType[];
  dateFrom?: string;
  dateTo?: string;
};

export const getDossierTransactions = (
  filters: DossierTransactionFilters,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, pageSize, transactionTypes, ...otherFilters } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossierTransactions", filters],
    queryFn: (): Promise<DossierTransactionPaginationList> => {
      return fetchWithAuth<DossierTransactionPaginationList>(
        "getDossierTransactions",
        filters.dossierId,
        {
          queryParams: {
            ...otherFilters,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
            transactionTypes: transactionTypes
              ? transactionTypes.join(",")
              : undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
